import { type_GM_STATE } from './types'

declare var GM_STATE: type_GM_STATE

/**
 * Get graphql headers required for Shopify
 */
function getGraphQlHeaders(): Headers {
  const headers = new Headers()
  headers.set('Content-Type', 'application/json')
  headers.set('Accept', 'application/json')
  headers.set('X-Shopify-Storefront-Access-Token', GM_STATE.apis.storefrontAccessToken ?? '')
  return headers
}

/**
 * Returns graphql request with no callback
 */
export function executeGraphQlQuery({ query, variables }: { query: string; variables?: any }) {
  if (!GM_STATE.apis.storefrontAccessToken || !GM_STATE.apis.graphQlEndpoint) {
    console.error('Must have storefront details defined at GM_STATE.storefrontAPI', GM_STATE)
    throw new Error('Missing required details for storefront API call')
  }
  const url = GM_STATE.apis.graphQlEndpoint
  // remove line breaks and double space for legibility
  const cleanQuery = query.replace(/\n/g, ' ').replace(/ {2}/g, '')
  const config = {
    method: 'post',
    headers: getGraphQlHeaders(),
    body: JSON.stringify({
      query: cleanQuery,
      // only add variables if they actually exist
      ...(variables ? { variables } : {})
    })
  }
  return fetch(url, config)
}
/**
 * Flattens edges and nodes out of an object
 */
export function extractNodes(parentNode: any, childNodeName: string) {
  return {
    ...parentNode,
    [childNodeName]: parentNode[childNodeName].edges.map((x: { node: any }) => x.node)
  }
}

// graphql ID may be - string '', ID, 123456789, gid: gid://shopify/Customer/123456789, or base64 encoded string
export function getIdFromGqlAsNumber(graphQlId: string): number | null {
  if (!graphQlId) {
    return null; // Return null if input is falsy
  }

  if (typeof graphQlId === 'string') {
    graphQlId = graphQlId.toString();
  }

  let decodedId = graphQlId;

  try {
    decodedId = atob(graphQlId); // Try decoding the ID if it’s Base64 encoded
  } catch (error) {
    // Decoding failed; assume it's not Base64 encoded
    // Optionally log this if needed:
    // console.warn('graphQLId may have already been decoded. graphQlId:', graphQlId, '. Error:', error);
  }

  // Extract numeric part from gid-style IDs
  decodedId = decodedId.includes('/') ? decodedId.split('/').slice(-1)[0] : decodedId;

  // Convert to a number
  const numericId = parseInt(decodedId, 10);

  return isNaN(numericId) ? null : numericId; // Return null if conversion fails
}
